(function ($) {
  'use strict'
  Drupal.behaviors.lowPromoSlider = {
    attach: function (context, settings) {
      const sliderOptions2 = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        breakpoints: {
          1025: {
            spaceBetween: 32,
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        }
      };

      setTimeout(() => {
        const swiper2 = new Swiper('.paragraph--low-promo-lane .swiper', sliderOptions2);
      });
    }
  };

}) (jQuery)